import React, { useState } from "react";
import { X, Mail, Lock, User } from "lucide-react";
type AuthModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
};
export function AuthModal({
  isOpen,
  onClose,
  onSuccess
}: AuthModalProps) {
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSuccess();
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-178">
      <div className="bg-white dark:bg-gray-800 rounded-xl w-full max-w-md relative" data-id="element-179">
        <button onClick={onClose} className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors" data-id="element-180">
          <X className="w-5 h-5" data-id="element-181" />
        </button>
        <div className="p-8" data-id="element-182">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-183">
            {isSignUp ? "Create your account" : "Welcome back"}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-184">
            {isSignUp ? "Start your journey to build your MVP" : "Sign in to continue to MVP scoping"}
          </p>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-185">
            {isSignUp && <div data-id="element-186">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-187">
                  Full Name
                </label>
                <div className="relative" data-id="element-188">
                  <User className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-189" />
                  <input type="text" value={name} onChange={e => setName(e.target.value)} className="pl-10 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="John Doe" required data-id="element-190" />
                </div>
              </div>}
            <div data-id="element-191">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-192">
                Email
              </label>
              <div className="relative" data-id="element-193">
                <Mail className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-194" />
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="pl-10 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="you@example.com" required data-id="element-195" />
              </div>
            </div>
            <div data-id="element-196">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-197">
                Password
              </label>
              <div className="relative" data-id="element-198">
                <Lock className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-199" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="pl-10 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="••••••••" required data-id="element-200" />
              </div>
            </div>
            <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-201">
              {isSignUp ? "Create Account" : "Sign In"}
            </button>
          </form>
          <p className="mt-4 text-center text-sm text-gray-600" data-id="element-202">
            {isSignUp ? "Already have an account? " : "Don't have an account? "}
            <button onClick={() => setIsSignUp(!isSignUp)} className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-203">
              {isSignUp ? "Sign In" : "Sign Up"}
            </button>
          </p>
        </div>
      </div>
    </div>;
}